import React from 'react';

// Import Material Icons for clarity
import { Person, Visibility, VerifiedUser, TrendingUp } from '@mui/icons-material';

const StyledList = () => {
  return (
    <ul style={{ listStyleType: 'none', padding: 0, margin: 0 }}>
      {/* Customer-Centric Approach */}
      <li style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <div
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: '#2980b9',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '15px',
          }}
        >
          <Person style={{ color: 'white', fontSize: '20px' }} />
        </div>
        <div>
          <strong style={{ fontSize: '18px', color: '#2980b9' }}>
            Customer-Centric Approach:
          </strong>
          <p style={{ margin: '5px 0', color: '#555', fontSize: '16px' }}>
            Your financial well-being is our priority. We take the time to
            understand your unique needs and craft personalized solutions that
            work for you.
          </p>
        </div>
      </li>

      {/* Transparency */}
      <li style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <div
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: '#27ae60',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '15px',
          }}
        >
          <Visibility style={{ color: 'white', fontSize: '20px' }} />
        </div>
        <div>
          <strong style={{ fontSize: '18px', color: '#27ae60' }}>Transparency:</strong>
          <p style={{ margin: '5px 0', color: '#555', fontSize: '16px' }}>
            We believe in complete honesty and openness in all our dealings,
            ensuring that you have a clear understanding of your financial
            options.
          </p>
        </div>
      </li>

      {/* Trust & Integrity */}
      <li style={{ display: 'flex', alignItems: 'center', marginBottom: '20px' }}>
        <div
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: '#f39c12',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '15px',
          }}
        >
          <VerifiedUser style={{ color: 'white', fontSize: '20px' }} />
        </div>
        <div>
          <strong style={{ fontSize: '18px', color: '#f39c12' }}>Trust & Integrity:</strong>
          <p style={{ margin: '5px 0', color: '#555', fontSize: '16px' }}>
            Building lasting relationships based on trust is at the heart of
            what we do. Our team of experts is committed to providing reliable
            and ethical financial advice.
          </p>
        </div>
      </li>

      {/* Growth-Oriented Solutions */}
      <li style={{ display: 'flex', alignItems: 'center' }}>
        <div
          style={{
            width: '40px',
            height: '40px',
            borderRadius: '50%',
            backgroundColor: '#8e44ad',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: '15px',
          }}
        >
          <TrendingUp style={{ color: 'white', fontSize: '20px' }} />
        </div>
        <div>
          <strong style={{ fontSize: '18px', color: '#8e44ad' }}>
            Growth-Oriented Solutions:
          </strong>
          <p style={{ margin: '5px 0', color: '#555', fontSize: '16px' }}>
            Whether you're an individual looking to secure your financial
            future or a business aiming to scale new heights, we offer
            strategies that foster sustainable growth.
          </p>
        </div>
      </li>
    </ul>
  );
};

export default StyledList;
